<div class="full-page-overlay" *ngIf="isLoader">
    <div class="rfqLoader"></div>
  </div>